import React from 'react';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import { Button } from '@material-ui/core';
import GridContainer from '@jumbo/components/GridContainer';
/* import LinkList from '@jumbo/components/LinkList'; */
import { /* FICHAS_TECNICAS_LINK_LIST_BUTTONS, */ TEXTO_FICHAS_TECNICAS } from '../ConstsAndUtils/utils';
import { Edit } from '@material-ui/icons';
import { GESTION_FT, TEXT_COLOR_FT } from 'config/config';

const SinFicha = props => {
  const { openCondiciones } = props;
  const user = JSON.parse(sessionStorage.getItem('user'));
  const roles_user = user.roles_user


  const isAdmin = () => {
    return roles_user.some(role => role.name === GESTION_FT)
  }


  return (
    <GridContainer>
      <Grid item xs={12} style={{ color: TEXT_COLOR_FT }}>
        <div style={{ marginBottom: 10 }}>
          <h1 style={{ fontSize: 22 }}>
            Ingreso y actualización de datos en ficha técnica para Prestadores Institucionales
          </h1>
          <br></br>
          <p>{TEXTO_FICHAS_TECNICAS}</p>
        </div>
        <Divider />
        <br />
        <GridContainer>
          <Grid item xs={12}>
            <Button
              disabled={!isAdmin()}
              fullWidth
              onClick={openCondiciones}
              style={{
                backgroundColor: '#23bcba',
                color: 'whitesmoke',
                fontSize: 22,
                paddingTop: 35,
                paddingBottom: 35,
                borderRadius: 20,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}>
              {
                isAdmin() ?
                  <span style={{ flex: 1 }}>Iniciar Proceso de registro</span>
                  :
                  <span style={{ flex: 1 }}>Solo el Administrador puede iniciar el proceso de registro</span>
              }
              <Edit style={{ marginRight: 10 }} />
            </Button>
          </Grid>
        </GridContainer>

        {/*         <div style={{ marginTop: 0 }}>
          <LinkList buttons={FICHAS_TECNICAS_LINK_LIST_BUTTONS} />
        </div> */}
      </Grid>
    </GridContainer>
  );
};

export default SinFicha;
